<!-- Loading skeleton -->
<div *ngIf="isLoading" class="lev-card placeholder-glow">
  <div class="lev-header">
    <div class="lev-header-meta" style="flex:1">
      <span class="placeholder col-4 d-block mb-2" style="height:12px;"></span>
      <span class="placeholder col-7 d-block" style="height:20px;"></span>
    </div>
    <div class="lev-header-right">
      <span class="placeholder col-12 d-block mb-2" style="width:80px;height:16px;"></span>
      <span class="placeholder rounded-pill" style="width:60px;height:22px;display:block;"></span>
    </div>
  </div>
  <div class="lev-section">
    <div class="lev-section-header mb-2">
      <span class="placeholder col-4" style="height:14px;"></span>
      <span class="placeholder col-3" style="height:14px;"></span>
    </div>
    <span class="placeholder col-12 d-block" style="height:10px;border-radius:50px;"></span>
  </div>
  <div class="lev-section mb-0">
    <span class="placeholder col-5 d-block mb-3" style="height:14px;"></span>
    <div class="lev-results-grid">
      <div *ngFor="let i of [0,1,2,3]" class="lev-result-card">
        <span class="placeholder rounded-circle" style="width:28px;height:28px;display:block;"></span>
        <span class="lev-result-info">
          <span class="placeholder col-6 d-block mb-1" style="height:16px;"></span>
          <span class="placeholder col-8 d-block" style="height:12px;"></span>
        </span>
      </div>
    </div>
  </div>
</div>

<div class="lev-card" *ngIf="!isLoading && cycle">

    <!-- Header -->
    <div class="lev-header">
        <div class="lev-header-meta">
            <span class="lev-label">Latest Execution</span>
            <div class="lev-title-row">
                <span class="lev-name">{{ cycle.name }}</span>
            </div>
        </div>
        <div class="lev-header-right">
            <span class="lev-test-count">
                <img class="my-auto" src="assets/images/virtusa-icons/document-icon.svg" alt="passed" />
                {{ cycle.totalCount }} Test Case(s)
            </span>
            <app-status-badge [status]="cycle.status" size="small"></app-status-badge>
        </div>
    </div>

    <!-- Overall Progress -->
    <div class="lev-section">
        <div class="lev-section-header">
            <h4 class="lev-section-title">Overall Progress</h4>
            <span class="lev-completion-label">{{ completedLabel }}</span>
        </div>
        <app-multi-segment-progress-bar [counts]="{
        passed:    cycle.passedCount,
        failed:    cycle.failedCount,
        executing: cycle.executingCount,
        waiting:   cycle.waitingCount
      }" [total]="cycle.totalCount" [barHeight]="20" [borderRadius]="50">
        </app-multi-segment-progress-bar>
    </div>

    <!-- Test Results Overview -->
    <div class="lev-section mb-0">
        <h4 class="lev-section-title">Test Results Overview</h4>
        <div class="lev-results-grid">

            <div class="lev-result-card lev-passed">
                <span class="lev-result-icon">
                    <img class="my-auto" src="assets/images/virtusa-icons/passed-icon.svg" alt="passed" />
                </span>
                <span class="lev-result-info">
                    <span class="lev-result-count">{{ cycle.passedCount }}</span>
                    <span class="lev-result-label">Passed</span>
                </span>
            </div>

            <div class="lev-result-card lev-failed">
                <span class="lev-result-icon">
                    <img class="my-auto" src="assets/images/virtusa-icons/failed-icon.svg" alt="failed" />
                </span>
                <span class="lev-result-info">
                    <span class="lev-result-count">{{ cycle.failedCount }}</span>
                    <span class="lev-result-label">Failed</span>
                </span>
            </div>

            <div class="lev-result-card lev-executing">
                <span class="lev-result-icon">
                    <img class="my-auto" src="assets/images/virtusa-icons/executing.svg" alt="executing" />
                </span>
                <span class="lev-result-info">
                    <span class="lev-result-count">{{ cycle.executingCount }}</span>
                    <span class="lev-result-label">Executing</span>
                </span>
            </div>

            <div class="lev-result-card lev-waiting">
                <span class="lev-result-icon">
                    <img class="my-auto" src="assets/images/virtusa-icons/waiting.svg" alt="waiting" />
                </span>
                <span class="lev-result-info">
                    <span class="lev-result-count">{{ cycle.waitingCount }}</span>
                    <span class="lev-result-label">Waiting</span>
                </span>
            </div>

        </div>
    </div>

    <!-- Execution Timeline -->
    <div class="lev-section mt-0">
        <h4 class="lev-section-title">Execution Timeline</h4>
        <div class="lev-timeline">
            <div class="lev-timeline-row">
                <span class="lev-tl-label">Start Time</span>
                <span class="lev-tl-value">{{ formatDate(cycle.startTime) }}</span>
            </div>
            <div class="lev-timeline-row">
                <span class="lev-tl-label">End Time</span>
                <span class="lev-tl-value">{{ formatDate(cycle.endTime) }}</span>
            </div>
            <div class="lev-timeline-row">
                <span class="lev-tl-label">Duration</span>
                <strong class="lev-tl-value lev-tl-duration">{{ calculateDuration() }}</strong>
            </div>
        </div>
    </div>

</div>